import {formatUnitTree} from "@/utils/format"
import http from "@/http"
import wx from "weixin-js-sdk";
import storage from "@/utils/storage"
import store from "../../store";


const state = {
    openId: '',
    appId: '',
    position: null,
    SDK: false,
};

const actions = {
   async getAppId({commit, dispatch}, {payload}) {
      const bo = await http.wechat.getAppId({})
            .then(ret => {
                if (ret) {
                    const {appId} = ret
                    commit('Success', {appId});
                    storage.setCache("appId", appId);
                    return true
                }
                return false
            })
       return bo
    },
    auth() {
        http.wechat.auth()
    },
    getOpenId({commit, dispatch}, {payload}) {
        const {to, from, next, router, code} = payload
        http.wechat.getOpenId({code})
            .then(ret => {
                if (ret) {
                    const openId = ret.openid
                    console.info('openId',openId)
                    commit('Success', {openId});
                    // dispatch({type: 'global/login'})

                    storage.setCache("openId", openId);
                    storage.setCache("headers", {
                        'Access-Token': openId
                    });
                    dispatch({type: 'getSDK'})
                    store.dispatch({type: 'global/login', payload: {to, next}})
                    window.location.search = "" // 清除code信息
                } else {
                    router.replace("/account/bind");
                }
            })
    },
    getSDK({dispatch, commit}) {
        http.wechat.getSDK({url: encodeURIComponent(location.href.split("#")[0])})
            .then(ret => {
                if (ret) {
                    wx.config({
                        debug: false,
                        appId: ret.appId,
                        timestamp: ret.timestamp,
                        nonceStr: ret.nonceStr,
                        signature: ret.signature,
                        jsApiList: [
                            "scanQRCode",
                            "getLocation",
                            "openLocation",
                            "chooseImage",
                            "uploadImage",
                            "downloadImage",
                            "getLocalImgData",
                            "openLocation",
                            "startRecord",
                            "stopRecord",
                            "onVoiceRecordEnd",
                            "playVoice",
                            "makePhoneCall",
                            "uploadVoice",
                            "downloadVoice",
                        ]
                    });
                    wx.ready(function () {
                        dispatch({type: 'init'})
                        commit('Success', {SDK: true});
                    });
                    wx.error(function () {
                        setTimeout(() => dispatch({type: 'getSDK'}), 2000)
                    });
                } else {
                    setTimeout(() => dispatch({type: 'getSDK'}), 2000)
                }
            })
    },
    init({dispatch}) {
        dispatch({type: 'getLocation'})
    },
    getLocation({commit, getters}) {
        wx.getLocation({
            type: 'gcj02',
            success: function (res) {
                const position = {
                    latitude: res.latitude,
                    longitude: res.longitude,
                    address: ''
                }
                new AMap.Geocoder().getAddress([position.longitude, position.latitude],
                    function (status, result) {
                        if ('complete' === status) {
                            position.address = result.regeocode.formattedAddress
                        }
                        storage.setCache('position', position)
                        commit('Success', {position});
                    });

            },
            cancel: function (res) {
                console.error("用户拒绝授权获取地理位置");
            },
            fail: function (res) {
                console.error('获取地理位置失败');
            }
        }); //end wx.getLocation
    },
};

const getters = {
    openId: state => state.openId || storage.getCache("openId"),
    appId: state => state.appId || storage.getCache("appId"),
    SDK: state => state.SDK,
    position: state => state.position || storage.getCache("position") || {
        latitude: 39.56,
        longitude: 116.20,
        address: '中国'
    },

};

const mutations = {
    Success(state, payload) {
        Object.keys(payload).map(key => {
            state[key] = payload[key]
        })
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
